var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamiUsoArtesanalEmbalajesDomestico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#A1A3A6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.1,20.2c0.6,0.6,1.5,0.9,2.6,0.9s1.9-0.3,2.6-0.9c0.6-0.6,0.9-1.5,0.9-2.6v-8h2.8v8.1 c0,1.2-0.3,2.2-0.8,3.1s-1.2,1.6-2.2,2c-0.9,0.5-2.1,0.7-3.3,0.7c-1.3,0-2.4-0.2-3.4-0.7s-1.7-1.1-2.2-2s-0.8-1.9-0.8-3.1V9.6h2.8 v8.1C120.1,18.7,120.4,19.6,121.1,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,12.1c-0.8-0.2-1.5-0.4-2.1-0.4c-0.7,0-1.2,0.1-1.6,0.4s-0.6,0.6-0.6,1s0.1,0.7,0.4,1s0.6,0.5,1,0.6 c0.4,0.2,1,0.3,1.7,0.5c1,0.3,1.8,0.5,2.4,0.8c0.6,0.3,1.2,0.7,1.6,1.2c0.4,0.5,0.7,1.2,0.7,2.1c0,0.8-0.2,1.6-0.7,2.2 s-1.1,1.1-2,1.4c-0.8,0.3-1.8,0.5-2.9,0.5c-1.1,0-2.2-0.2-3.3-0.6s-2-0.9-2.8-1.6L133,19c0.7,0.6,1.5,1.1,2.5,1.5 c0.9,0.4,1.8,0.5,2.5,0.5c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.7,0.7-1.1s-0.1-0.7-0.4-1s-0.6-0.5-1-0.6s-1-0.3-1.7-0.5 c-1-0.3-1.8-0.5-2.4-0.8c-0.6-0.3-1.1-0.7-1.6-1.2c-0.4-0.5-0.7-1.2-0.7-2.1c0-0.8,0.2-1.5,0.7-2.1c0.4-0.6,1.1-1.1,1.9-1.4 c0.8-0.3,1.8-0.5,2.8-0.5c0.9,0,1.9,0.1,2.8,0.4c0.9,0.3,1.7,0.6,2.4,1.1l-1.1,2.3C141.5,12.7,140.8,12.3,140,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.6,10.3c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6s-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9s-2.7-0.3-3.9-0.9s-2.1-1.5-2.8-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5s2.5-0.9,3.9-0.9 S155.5,9.7,156.6,10.3z M150.3,12.4c-0.8,0.4-1.4,1-1.8,1.7c-0.4,0.7-0.7,1.5-0.7,2.4c0,0.9,0.2,1.7,0.7,2.4s1,1.3,1.8,1.7 c0.7,0.4,1.6,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6s1.3-1,1.8-1.7s0.6-1.5,0.6-2.4s-0.2-1.7-0.6-2.4c-0.4-0.7-1-1.3-1.8-1.7 c-0.7-0.4-1.5-0.6-2.4-0.6C151.9,11.7,151.1,11.9,150.3,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.6,23.3l-1.3-2.9h-7.1l-1.3,2.9H166l6.3-13.7h2.9l6.2,13.7H178.6z M171.2,18.1h5.1l-2.5-5.8L171.2,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.3,23.3l-2.5-4.1c-0.1,0-0.3,0-0.5,0H186v4h-2.8V9.6h6c1.9,0,3.3,0.4,4.3,1.2s1.5,2,1.5,3.5 c0,1.1-0.2,2-0.7,2.7c-0.5,0.8-1.2,1.3-2.1,1.7l3.2,4.6C195.4,23.3,192.3,23.3,192.3,23.3z M186.1,16.9h3.3c1,0,1.8-0.2,2.4-0.6 c0.5-0.4,0.8-1.1,0.8-1.9c0-0.8-0.3-1.5-0.8-1.9c-0.6-0.4-1.3-0.6-2.4-0.6h-3.3V16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.6,9.6h11.8v2.3h-4.5v11.4h-2.8V11.9h-4.5V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.3,9.6h10.6v2.3h-7.8v3.4h7v2.3h-7V21h8.1v2.3h-10.8V9.6H210.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.8,12.1c-0.8-0.2-1.5-0.4-2.1-0.4c-0.7,0-1.2,0.1-1.6,0.4s-0.6,0.6-0.6,1s0.1,0.7,0.4,1s0.6,0.5,1,0.6 c0.4,0.2,1,0.3,1.7,0.5c1,0.3,1.8,0.5,2.4,0.8s1.2,0.7,1.6,1.2c0.4,0.5,0.7,1.2,0.7,2.1c0,0.8-0.2,1.6-0.7,2.2s-1.1,1.1-2,1.4 c-0.8,0.3-1.8,0.5-2.9,0.5c-1.1,0-2.2-0.2-3.3-0.6s-2-0.9-2.8-1.6l1.2-2.2c0.7,0.6,1.5,1.1,2.5,1.5c0.9,0.4,1.8,0.5,2.5,0.5 c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.7,0.7-1.1s-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.5-1-0.6s-1-0.3-1.7-0.5c-1-0.3-1.8-0.5-2.4-0.8 c-0.6-0.3-1.1-0.7-1.6-1.2c-0.4-0.5-0.7-1.2-0.7-2.1c0-0.8,0.2-1.5,0.7-2.1c0.4-0.6,1.1-1.1,1.9-1.4c0.8-0.3,1.8-0.5,2.8-0.5 c0.9,0,1.9,0.1,2.8,0.4c0.9,0.3,1.7,0.6,2.4,1.1l-1.1,2.3C232.3,12.7,231.5,12.3,230.8,12.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.5,23.3l-1.3-2.9h-7.1l-1.3,2.9H235l6.3-13.7h2.9l6.2,13.7H247.5z M240.2,18.1h5.1l-2.5-5.8L240.2,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.3,9.6h2.7v13.7h-2.6l-7.4-9.5v9.5h-2.7V9.6h2.6l7.4,9.5L262.3,9.6L262.3,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.2,23.3l-1.3-2.9h-7.1l-1.3,2.9h-2.9l6.3-13.7h2.9l6.2,13.7H279.2z M271.9,18.1h5.1l-2.5-5.8L271.9,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.9,9.6h2.8V21h6.2v2.4h-9V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6,21.1c0.3,0.2,0.4,0.6,0.4,1c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.6l-1.3,2.4H294l0.9-2.3 c-0.4-0.3-0.6-0.6-0.6-1.1c0-0.4,0.1-0.7,0.4-1s0.6-0.4,1-0.4C296,20.7,296.3,20.8,296.6,21.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.3,42.5l-1.3-2.9h-7l-1.3,2.9h-2.9l6.3-13.7h2.9l6.2,13.7H128.3z M121,37.3h5.1l-2.5-5.8L121,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133,28.7h2.8v11.4h6.2v2.4h-9V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.2,28.7h2.8v13.7h-2.8V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.5,28.7h3.2l4.8,8.9l4.7-8.9h3.2v13.7h-2.5v-9.9l-4.5,8.4h-1.8l-4.5-8.4v9.9h-2.5L150.5,28.7L150.5,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.9,28.7h10.6V31h-7.8v3.4h7v2.3h-7v3.5h8.1v2.3H170V28.7H169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.6,28.7h2.7v13.7h-2.6l-7.4-9.5v9.5h-2.7V28.7h2.6l7.4,9.5V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.2,28.7H210V31h-4.5v11.4h-2.8V31h-4.5V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.9,28.7h2.8v13.7h-2.8V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.9,31.4c-0.7-0.3-1.4-0.5-2.1-0.5c-0.9,0-1.7,0.2-2.5,0.6s-1.3,1-1.8,1.7c-0.4,0.7-0.6,1.5-0.6,2.3 s0.2,1.6,0.6,2.3c0.4,0.7,1,1.3,1.8,1.7c0.7,0.4,1.6,0.6,2.5,0.6c0.7,0,1.4-0.1,2.1-0.4c0.7-0.3,1.3-0.7,1.8-1.2l1.6,1.7 c-0.8,0.7-1.6,1.3-2.6,1.7s-2,0.6-3.1,0.6c-1.4,0-2.7-0.3-3.8-0.9c-1.2-0.6-2.1-1.5-2.7-2.6c-0.7-1.1-1-2.3-1-3.6s0.3-2.5,1-3.6 s1.6-1.9,2.8-2.5s2.4-0.9,3.9-0.9c1,0,2,0.2,3,0.6s1.8,0.9,2.5,1.6l-1.6,1.9C228.2,32.1,227.6,31.7,226.9,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.6,28.7h2.8v13.7h-2.8V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.4,29.5c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6s-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9s-2.7-0.3-3.9-0.9c-1.2-0.6-2.1-1.5-2.8-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5s2.5-0.9,3.9-0.9 S248.2,28.8,249.4,29.5z M243,31.5c-0.8,0.4-1.4,1-1.8,1.7c-0.4,0.7-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4c0.4,0.7,1,1.3,1.8,1.7 s1.6,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6s1.3-1,1.8-1.7c0.4-0.7,0.6-1.5,0.6-2.4s-0.2-1.7-0.6-2.4c-0.4-0.7-1-1.3-1.8-1.7 s-1.5-0.6-2.4-0.6C244.6,30.9,243.8,31.1,243,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.2,28.7L267,38v4.5h-2.8v-4.4l-5.4-9.3h2.8l3.9,6.5l3.9-6.5L272.2,28.7L272.2,28.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289,29.6c1.1,0.6,2,1.4,2.7,2.4c0.6,1,1,2.2,1,3.6s-0.3,2.5-1,3.5s-1.6,1.9-2.7,2.4c-1.2,0.6-2.5,0.9-3.9,0.9 h-5.9V28.7h6C286.5,28.7,287.8,29,289,29.6z M287.5,39.6c0.7-0.4,1.3-0.9,1.7-1.6s0.6-1.5,0.6-2.3s-0.2-1.7-0.6-2.4s-1-1.2-1.7-1.6 s-1.5-0.6-2.4-0.6h-3.2v9.1h3.3C286,40.1,286.8,39.9,287.5,39.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305,29.5c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6s-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9s-2.7-0.3-3.9-0.9c-1.2-0.6-2.1-1.5-2.8-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5 c1.2-0.6,2.5-0.9,3.9-0.9S303.8,28.8,305,29.5z M298.7,31.5c-0.8,0.4-1.4,1-1.8,1.7s-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4 c0.4,0.7,1,1.3,1.8,1.7s1.6,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6c0.7-0.4,1.3-1,1.8-1.7c0.4-0.7,0.7-1.5,0.7-2.4s-0.2-1.7-0.7-2.4 c-0.4-0.7-1-1.3-1.8-1.7c-0.7-0.4-1.5-0.6-2.4-0.6C300.3,30.9,299.4,31.1,298.7,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.2,28.7h3.2l4.8,8.9l4.7-8.9h3.2v13.7h-2.5v-9.9L320,41h-1.8l-4.5-8.4v9.9h-2.5V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.6,28.7h10.6V31h-7.8v3.4h7v2.3h-7v3.5h8.1v2.3h-10.8V28.7H330.6z M336.9,24.6l2.6,1l-2.6,2l-2.1-0.2 L336.9,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351,31.2c-0.8-0.2-1.5-0.4-2.1-0.4c-0.7,0-1.2,0.1-1.6,0.4c-0.4,0.2-0.6,0.6-0.6,1c0,0.4,0.1,0.7,0.4,1 s0.6,0.5,1,0.6c0.4,0.2,1,0.3,1.7,0.5c1,0.3,1.8,0.5,2.4,0.8s1.2,0.7,1.6,1.2s0.7,1.2,0.7,2.1c0,0.8-0.2,1.6-0.7,2.2 c-0.5,0.6-1.1,1.1-2,1.4c-0.8,0.3-1.8,0.5-2.9,0.5s-2.2-0.2-3.3-0.6c-1.1-0.4-2-0.9-2.8-1.6l1.2-2.2c0.7,0.6,1.5,1.1,2.5,1.5 c0.9,0.4,1.8,0.5,2.5,0.5c0.8,0,1.4-0.1,1.8-0.4c0.4-0.3,0.7-0.7,0.7-1.1c0-0.4-0.1-0.7-0.4-1s-0.6-0.5-1-0.6 c-0.4-0.2-1-0.3-1.7-0.5c-1-0.3-1.8-0.5-2.4-0.8s-1.1-0.7-1.6-1.2s-0.7-1.2-0.7-2.1c0-0.8,0.2-1.5,0.7-2.1s1.1-1.1,1.9-1.4 s1.8-0.5,2.8-0.5c0.9,0,1.9,0.1,2.8,0.4s1.7,0.6,2.4,1.1l-1.1,2.3C352.6,31.8,351.8,31.5,351,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.6,28.7h11.8V31h-4.5v11.4h-2.8V31h-4.5V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.3,28.7h2.8v13.7h-2.8V28.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.3,31.4c-0.7-0.3-1.4-0.5-2.1-0.5c-0.9,0-1.7,0.2-2.5,0.6s-1.3,1-1.8,1.7c-0.4,0.7-0.6,1.5-0.6,2.3 s0.2,1.6,0.6,2.3s1,1.3,1.8,1.7c0.7,0.4,1.6,0.6,2.5,0.6c0.7,0,1.4-0.1,2.1-0.4c0.7-0.3,1.3-0.7,1.8-1.2l1.6,1.7 c-0.8,0.7-1.6,1.3-2.6,1.7s-2,0.6-3.1,0.6c-1.4,0-2.7-0.3-3.8-0.9c-1.2-0.6-2.1-1.5-2.7-2.6c-0.7-1.1-1-2.3-1-3.6s0.3-2.5,1-3.6 s1.6-1.9,2.8-2.5c1.2-0.6,2.5-0.9,3.9-0.9c1,0,2,0.2,3,0.6s1.8,0.9,2.5,1.6l-1.6,1.9C385.6,32.1,385,31.7,384.3,31.4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.2,29.5c1.2,0.6,2.1,1.5,2.8,2.5c0.7,1.1,1,2.3,1,3.6s-0.3,2.5-1,3.6s-1.6,1.9-2.8,2.6 c-1.2,0.6-2.5,0.9-3.9,0.9s-2.7-0.3-3.9-0.9c-1.2-0.6-2.1-1.5-2.8-2.6s-1-2.3-1-3.6s0.3-2.5,1-3.6s1.6-1.9,2.8-2.5 c1.2-0.6,2.5-0.9,3.9-0.9S399,28.8,400.2,29.5z M393.8,31.5c-0.8,0.4-1.4,1-1.8,1.7s-0.7,1.5-0.7,2.4s0.2,1.7,0.7,2.4 c0.4,0.7,1,1.3,1.8,1.7c0.7,0.4,1.6,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6c0.7-0.4,1.3-1,1.8-1.7c0.4-0.7,0.7-1.5,0.7-2.4 s-0.2-1.7-0.7-2.4c-0.4-0.7-1-1.3-1.8-1.7c-0.7-0.4-1.5-0.6-2.4-0.6C395.4,30.9,394.6,31.1,393.8,31.5z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.4,36.3 32.1,42.5 40.5,31.1 46.8,31.1 46.8,9.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 9.5,
    className: "st1",
    width: 7.7,
    height: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 9.5,
    className: "st1",
    width: 7.7,
    height: 33.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.5,43 60.8,43 60.8,14.4 68.5,22.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.8,43 91.4,43 91.4,14.4 83.9,22.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "60.8,9.5 69.3,9.5 75.9,17.9 83.1,9.4 91.4,9.5 91.4,12.4 75.9,27.9 60.8,12.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.7,17.5L31,42.8h-9.9L3.9,20.6V9.4h16c0,0,8.6,0.4,9.5,10.9c0,0,0.5,7.7-5.9,10.7l-5.6-7.1c0,0,3,0.5,3-3 c0,0,0-3.1-2.9-3.2h-6.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.8,22.3 11.7,32.3 11.7,42.8 3.9,42.8  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.9,22.6 11.7,32.7 11.7,43.1 3.9,43.1  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamiUsoArtesanalEmbalajesDomestico);
export default __webpack_public_path__ + "static/media/rami-uso-artesanal-embalajes-domestico.e400becf126d3b53f0349f82696d2a7e.svg";
export { ForwardRef as ReactComponent };